import { HOME_PAGE, ORDER_PAGE, ORDERHISTORY_PAGE, PLANNING_PAGE, HELP_PAGE, ORDERINFO_PAGE, CNCINFO_PAGE } from '../constants/ActionTypes'
import { useTranslation } from 'react-i18next';
import * as bottomBarActions from '../constants/BottomBarActions';
const { t } = useTranslation();

const initialState = {
    Title : 'Geen', 
    ShowBottomBarAction: false,
    BottomBarActionTitle: t('Back'),
    BottomBarAction: bottomBarActions.Actions.Home
};

export default function nav(state = initialState, action) {
    switch (action.type) {
        case HOME_PAGE:
            if(state.Title !== t('Home')) {
                return Object.assign({}, state, {Title: t('Home'), ShowBottomBarAction: false, AdditionalTitleInfo: ""});
            }
            return state;
        case ORDER_PAGE:
            if(state.Title !== t('Production')) {                
                return Object.assign({}, state, {Title: t('Production'), ShowBottomBarAction: true, BottomBarActionTitle: t('Back'), BottomBarAction: bottomBarActions.Actions.Back, AdditionalTitleInfo: ""});
            }
            return state;
        case ORDERHISTORY_PAGE:
            if(state.Title !== t('OrderHistory')) {
                return Object.assign({}, state, {Title: t('OrderHistory'), ShowBottomBarAction: true, BottomBarActionTitle: t('Back'), BottomBarAction: bottomBarActions.Actions.Back, AdditionalTitleInfo: ""});
            }
            return state;
        case PLANNING_PAGE:
            if(state.Title !== t('Planning')) {
                return Object.assign({}, state, {Title: t('Planning'), ShowBottomBarAction: true, BottomBarActionTitle: t('Back'), BottomBarAction: bottomBarActions.Actions.Back, AdditionalTitleInfo: ""});
            }
            return state;
        case HELP_PAGE:
                if(state.Title !== t('Help')) {
                    return Object.assign({}, state, {Title: t('Help'), ShowBottomBarAction: true, BottomBarActionTitle: t('Home'), BottomBarAction: bottomBarActions.Actions.Home, AdditionalTitleInfo: ""});
                }
                return state;
        case ORDERINFO_PAGE:
                let pageTitle = t('Order');

                if(state.Title !== pageTitle) {
                    return Object.assign({}, state, { Title: pageTitle, ShowBottomBarAction: true, BottomBarActionTitle: t('Back'), BottomBarAction: bottomBarActions.Actions.Back, AdditionalTitleInfo: ": " + action.orderNumber});
                }
                return state;
        case CNCINFO_PAGE:
                let cncpageTitle = t('Order');
    
                if(state.Title !== cncpageTitle) {
                    return Object.assign({}, state, { Title: cncpageTitle, ShowBottomBarAction: true, BottomBarActionTitle: t('Back'), BottomBarAction: bottomBarActions.Actions.Back, AdditionalTitleInfo: ": " + action.orderNumber});
                }
                return state;
        default:
            return state;
    }
}